import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <span className="text-sm uppercase tracking-[0.2em] text-[#1B19A8] font-semibold">Öğrenci Yorumları</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#1a1a1a] mt-4 leading-tight">
            Onlar başardı, <span className="text-[#1B19A8]">sıra sende.</span>
          </h2>
        </div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="grid md:grid-cols-3 gap-5"
        >
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.name}
              variants={fadeUp}
              custom={i}
              className="relative rounded-3xl bg-white border border-black/5 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.04)]"
            >
              <Quote size={36} className="text-[#1B19A8]/15 mb-4" />
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.stars }).map((_, s) => (
                  <Star key={s} size={16} className="fill-[#FFE500] text-[#FFE500]" />
                ))}
              </div>
              <p className="text-[#1a1a1a]/75 leading-relaxed mb-6">{`"${t.text}"`}</p>
              <div className="flex items-center gap-3">
                <div className="grid place-items-center w-11 h-11 rounded-full bg-[#1B19A8] text-white font-display font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-semibold text-[#1a1a1a]">{t.name}</div>
                  <div className="text-xs text-[#1a1a1a]/55">{t.uni}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
